export const ABT_YOURSELF = 'about-yourself';
export const METHOD_NAME = "sendData";
export const LQ_RESPONSE = 'LQResponse';